import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../Homepage/TravelSolution/TravelSolution.css";

const Captivatings = () => {
  return (
    <>
      <div className="container travel-solutions-section  mb-5">
        <div className="row ps-2">
          <div className="row">
            <div className="col-md-8  mt-3 paddingL">
              <h3 className="first-section headings">Captivating</h3>
              <div
                className="bgimage"
                style={{
                  "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                }}
              >
                <p className="mt-4 fs5">
                  With our impeccable technology and creative content, we are
                  willing to bring energy and focus to your event. Our expert
                  team handles logistics so you and your guests can relax in
                  peace.
                </p>
              </div>
              {/* <div className="exploreBtn d-flex gap-3">
                                <button className="btn btn-light bg-transparent border-0 outline-0 m-0 p-0 fs5 fw-bold explore-txt">EXPLORE
                                    MORE</button>
                                <button className="arrow-btn border-0 bg-transparent">
                                    <LazyLoadImage
            effect="blur"
 src={Rightarrow} alt="right-arrow" className="mt-1" />
                                </button>
                            </div> */}
            </div>
            <div className="col-md-4 right-side  d-none d-md-block">
              <div className="d-flex justify-content-center mt-2">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/captivating1.png"
                  alt=""
                  className=" mt-5 img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-8  mt-3 paddingL">
              <h3 className="second-section headings">Unforgettable</h3>
              <div
                className="bgimage"
                style={{
                  "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                }}
              >
                <p className="mt-4 fs5">
                  Welcome your colleagues and guests to our creative events
                  powered by innovative technology, activities, and formats.
                  With over 11 years of expertise, we know how to work by
                  staying within budget!
                </p>
              </div>
            </div>
            <div className="col-md-4 right-side  d-none d-md-block">
              <div className="d-flex justify-content-center mt-2">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/captivating2.png"
                  alt=""
                  className=" mt-5 img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-8  mt-3 paddingL">
              <h3 className="third-section headings">Powerful</h3>
              <div
                className="bgimage"
                style={{
                  "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                }}
              >
                <p className="mt-4 fs5">
                  Experience the power of seamless performance and impactful
                  results, as proved by 98% positive feedback and a track record
                  of driving effective ROI for our clients.
                </p>
              </div>
            </div>
            <div className="col-md-4 right-side  d-none d-md-block">
              <div className="d-flex justify-content-center mt-2">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/captivating3.png"
                  alt=""
                  className=" mt-5 img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Captivatings;
